(function () {
	'use strict';

	const COLOR_LABELS = {
		green: 'Viele Plätze frei',
		yellow: 'Noch einige Plätze frei',
		red: 'Fast voll',
	};

	// Leert das Alert-Element zuerst, dann setzt neuen Text –
	// so wird dieselbe Nachricht bei Wiederholung erneut vorgelesen.
	function announce(alertEl, message) {
		alertEl.textContent = '';
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				alertEl.textContent = message;
			});
		});
	}

	function updateBlock(block, data) {
		const ts = block.querySelector('.parking-occupancy-table__timestamp');
		if (ts) ts.textContent = 'Stand: ' + data.timestamp;

		block.querySelectorAll('[data-cleverciti-id]').forEach((row) => {
			const entry = data.entries[row.dataset.clevercitiId];
			if (!entry) return;

			const freeCell = row.querySelector('.parking-occupancy-table__free');
			const statusCell = row.querySelector('.parking-occupancy-table__status');

			if (!entry.is_open) {
				if (freeCell)
					freeCell.innerHTML = '<span class="parking-occupancy-table__closed">Geschlossen</span>';
				if (statusCell)
					statusCell.innerHTML =
						'<span class="cleverciti-indicator cleverciti-indicator--red" aria-hidden="true"></span>' +
						'<span class="parking-occupancy-table__closed">Geschlossen</span>';
				return;
			}

			if (freeCell) freeCell.textContent = String(entry.free);

			if (statusCell) {
				const label = COLOR_LABELS[entry.color] ?? '';
				const escaped = label.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
				statusCell.innerHTML =
					`<span class="cleverciti-indicator cleverciti-indicator--${entry.color}" ` +
					`role="img" aria-label="${escaped}"></span>` +
					`<span class="parking-occupancy-table__status-label">${label}</span>`;
			}
		});
	}

	async function refreshBlock(btn) {
		const block = btn.closest('.parking-occupancy-table-block');
		const alertEl = block.querySelector('.parking-refresh-status');

		btn.disabled = true;
		btn.setAttribute('aria-busy', 'true');
		btn.textContent = 'Wird aktualisiert…';

		const controller = new AbortController();
		const timeout = setTimeout(() => controller.abort(), 15000);

		try {
			const response = await fetch(btn.dataset.ajaxUrl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: new URLSearchParams({
					action: 'cdh_parking_refresh',
					nonce: btn.dataset.nonce,
				}).toString(),
				signal: controller.signal,
			});

			if (!response.ok) throw new Error('HTTP ' + response.status);

			const json = await response.json();

			if (json.success) {
				updateBlock(block, json.data);
				announce(alertEl, 'Belegungsdaten wurden aktualisiert.');
			} else {
				announce(
					alertEl,
					'Aktualisierung fehlgeschlagen: ' + (json.data?.message ?? 'Unbekannter Fehler.')
				);
			}
		} catch (err) {
			announce(
				alertEl,
				err.name === 'AbortError'
					? 'Zeitüberschreitung – bitte erneut versuchen.'
					: 'Verbindungsfehler – bitte erneut versuchen.'
			);
		} finally {
			clearTimeout(timeout);
			btn.disabled = false;
			btn.removeAttribute('aria-busy');
			btn.textContent = 'Daten aktualisieren';
		}
	}

	document.addEventListener('DOMContentLoaded', function () {
		document.querySelectorAll('.parking-refresh-btn').forEach((btn) => {
			btn.addEventListener('click', () => refreshBlock(btn));
		});
	});
})();
